import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      display: 'grid',
      gridTemplateColumns:'0.01fr 1fr 0.01fr',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      alignItems:'center',
      '& .arrowBack': {
          width:'24px',
          height:'24px',
          textDecoration:'none',
          color: 'black'
      },
      '& .title': {
        textAlign: 'center'
      },
      [theme.breakpoints.down('md')]: {
        '& .title': {
          fontSize: '1.5rem'
        }
      }
    },
    form: {
      maxWidth: "100%",
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(10),
      display: "flex",
      flexDirection: "column",
      alignItems: "left",
      justifyContent: "left"
    },
    section:{
      marginTop: theme.spacing(3),
      maxWidth: '66.666667%',
      flexBasis: '66.666667%',
      [theme.breakpoints.down("sm")]: {
        maxWidth: '100%',
        flexBasis: '100%'
      }
    },
    bodySection: {
      alignItems: 'center',
      marginBottom: theme.spacing(1.5),
      marginLeft: theme.spacing(0.5),
      width: "100%",
      gridColumnEnd: 'span 7',
      [theme.breakpoints.down("xs")]: {
        gridColumnEnd: 'span 12'
      }
    },
    cpButton: {
      [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing(3),
        marginTop: theme.spacing(1.5)
      }
    },
    cpSelect: {
      marginTop: theme.spacing(1.5),
      marginLeft: theme.spacing(3),
      [theme.breakpoints.down("sm")]: {
        marginLeft: theme.spacing(0)
      }
    },
    title: {
      marginTop: theme.spacing(3),
      [theme.breakpoints.down("xs")]: {
        fontSize: "22px"
      }
    },
    orderSummaryContainer: {
      alignSelf: 'flex-start',
      position: 'sticky',
      top: '10rem',
      '& div': {
        width: '100%',
        padding: '5px',
        border: 'none',
        boxShadow: 'none'
      },
      '& button': {
        backgroundColor: '#D32F2F',
        marginTop: '10px',
        width: '100%'
      },
      '& .total-label': {
        color: 'gray',
        marginRight: '10px'
      },
      '& .total-price': {
        color: '#D32F2F',
        fontWeight: '700'
      }
    },
    subtitle: {
      marginTop: theme.spacing(1),
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px"
      }
    }
  })
);
